import { request } from "@/plugins/axios";
import qs from 'qs';

// 用户联系业务员发送聊天信息
export async function userChat(params) {
    return await request({
        url: '/api/u_c/userChat',
        method: 'post',
        data:qs.stringify(params)
    })
}
//获取工厂地址簿列表
export async function orderList(params) {
    return await request({
        url: '/api/u_c/orderList',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 查询用户聊天记录
export async function userChatLog(params) {
    return await request({
        url: '/api/u_c/userChatLog',
        method: 'post',
        data:qs.stringify(params)
    })
}

// 用户回复聊天组信息
export async function groupReply(params) {
    return await request({
        url: '/api/u_c/groupReply',
        method: 'post',
        data:qs.stringify(params)
    })
}

// 查询游客聊天信息
export async function messageList(params) {
    return await request({
        url: '/api/u_c/messageList',
        method: 'post',
        data:qs.stringify(params)
    })
}
// 访客留言
export async function tourists(params) {
    return await request({
        url: '/api/u_c/tourists',
        method: 'post',
        data:qs.stringify(params)
    })
}

// 群聊
//管理员查询聊天组人员列表

export async function groups(params) {
    return await request({
        url: '/api/u_c/groups',
        method: 'post',
        data: params
    })
}
//管理员查询聊天组聊天信息
export async function groupsMessage(params) {
    return await request({
        url: '/api/u_c/groupsMessage',
        method: 'post',
        data: params
    })
}


// 改版的聊天模块
export async function contactsList(params) {
    return await request({
        url: '/api/u_c/contactsList',
        method: 'post',
        data: qs.stringify(params)
    })
}
// 是否在线
export async function saveOnLine(params) {
    return await request({
        url: '/api/u_c/saveOnLine',
        method: 'post',
        data: qs.stringify(params)
    })
}
// 获取群成员列表
export async function getGroupList(params) {
    return await request({
        url: '/api/u_c/groupUser',
        method: 'post',
        data: params
    })
}
// 组详情
export async function getGroupDetail(params) {
    return await request({
        url: '/api/a_t/groupDetail',
        method: 'post',
        data: params
    })
}
//管理员聊天留言回复
export async function adminReply(params) {
    return await request({
        url: '/api/u_c/userChat',
        method: 'post',
        data: params
    })
}
// 用户消息未读数
export async function unreadMessage(params) {
    return await request({
        url: '/api/u_c/unreadMessage',
        method: 'post',
        data: params
    })
}
// 游客消息未读数
export async function messageCount(params) {
    return await request({
        url: '/api/u_c/messageCount',
        method: 'post',
        data: params
    })
}